<template>
  <v-dialog
    content-class="dialog-top"
    :value="value"
    max-width="520"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title
        style="background-color: #5cb860; color: white;"
        class="headline"
      >
        Export Calendar
      </v-card-title>
      <v-card-text class="pt-4">
        <v-radio-group
          @change="onFormatChange"
          v-model="localFormat"
          row
          hide-details
          class="mt-0"
        >
          <v-radio label="Excel" value="excel" color="success"></v-radio>
          <v-radio label="PDF" value="pdf" color="success"></v-radio>

        </v-radio-group>

        <v-layout row wrap class="mt-2">
          <v-flex xs12 sm6 class="pr-sm-2">
            <v-text-field
              class="pr-5"
              :disabled="localFormat === 'pdf'"
              v-model="localStartDate"
              label="Start Date"
              type="date"
              :max="localEndDate"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="pl-sm-2">
            <v-text-field
              :disabled="localFormat === 'pdf'"
              v-model="localEndDate"
              label="End Date"
              type="date"
              :min="localStartDate"
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="default" @click="$emit('input', false)"
          >Cancel</v-btn
        >
        <v-btn small color="success" :disabled="!canExport" @click="emitExport">
          Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CalendarExportDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    defaultStartDate: {
      type: String,
      default: "",
    },
    defaultEndDate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localFormat: "excel",
      localStartDate: "",
      localEndDate: "",
    };
  },
  computed: {
    canExport() {
      return (
        !!this.localFormat &&
        !!this.localStartDate &&
        !!this.localEndDate &&
        this.localStartDate <= this.localEndDate
      );
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.resetDefaults();
      }
    },
    defaultStartDate() {
      if (this.value) this.localStartDate = this.defaultStartDate;
    },
    defaultEndDate() {
      if (this.value) this.localEndDate = this.defaultEndDate;
    },
  },
  methods: {
    onFormatChange() {
      this.localStartDate = this.defaultStartDate;
      this.localEndDate = this.defaultEndDate;
    },
    resetDefaults() {
      this.localFormat = "excel";
      this.localStartDate = this.defaultStartDate;
      this.localEndDate = this.defaultEndDate;
    },
    emitExport() {
      this.$emit("export", {
        format: this.localFormat,
        startDate:
          this.localFormat === "excel"
            ? this.defaultStartDate
            : this.localStartDate,
        endDate:
          this.localFormat === "excel" ? this.defaultEndDate : this.localEndDate,
      });
    },
  },
};
</script>
<style>
.dialog-top {
  align-self: flex-start;
  margin-top: 80px;
}
</style>
